import React, { Component } from 'react'

import get from 'lodash/get'
import PropTypes from 'prop-types'

import * as click from '../../../../../../assets/icons/click.svg'
import withTour from '../../../../../../components/hocs/withTour'
import Insight from '../../../../../../components/renderPropComponents/Insight'
import { dataToGaugeFromZoom } from '../../../../../../utils/resumesearch/dataTransformation'
import EducationDetailChart from '../../components/EducationDetailChart'
import ResultGauge from '../../components/ResultGauge'

const FIELD = 'field'
const ADVANCED_DEGREE = 'advancedDegree'

class EducationResult extends Component {
  static propTypes = {
    careerBreakdown: PropTypes.any.isRequired,
    gaugeMajorData: PropTypes.any.isRequired,
    zoomEducationData: PropTypes.any.isRequired,
    advancedDegreeData: PropTypes.any.isRequired,
    zoomDegreeData: PropTypes.any.isRequired,
    searchTerm: PropTypes.string,
    isMobile: PropTypes.bool.isRequired,
    onChangeResultsPage: PropTypes.func.isRequired,
    insight: PropTypes.object,
    searchClassificationString: PropTypes.string,
  }

  constructor() {
    super()
    this.state = {
      zoomChartData: null,
      activeInsite: FIELD,
    }
    this.showTopMajors = () => {
      window.dispatchEvent(new Event('resize'))
    }

    this.setZoomChartDataOnState = data => {
      this.setState({ zoomChartData: data })
    }
  }

  componentWillMount() {
    this.props.onChangeResultsPage('educationPage1')
  }

  componentDidMount() {
    const { careerBreakdown } = this.props
    if (careerBreakdown) {
      this.setZoomChartDataOnState(careerBreakdown)
    }
  }

  render() {
    const { careerBreakdown, advancedDegreeData, zoomDegreeData, isMobile, insight } = this.props
    const { zoomChartData, activeInsite } = this.state
    const gaugeFieldData = dataToGaugeFromZoom(careerBreakdown)

    const zoomChartContent = {
      field: {
        header: 'Where did they work?',
        tipContent:
          'Click into the chart to see more details about where your search results worked.',
      },
      advancedDegree: {
        header: 'How much education do I need?',
        tipContent: "What's the standard level of education for your industry?",
      },
    }

    return (
      <div>
        <div>
          <div className="card shadow">
            <div className="row m-0">
              {!isMobile && (
                <div className="col-md-6 p-0" id="statContainer">
                  <div style={{ borderBottom: '1px solid #ccc', padding: 10 }}>
                    <ResultGauge
                      gaugeFieldData={gaugeFieldData}
                      chartHeight={200}
                      textBottom={false}
                      content={
                        <div>
                          Have jobs in the <b>{get(careerBreakdown, 'subvalues[0].name', '')}</b>{' '}
                          field.
                        </div>
                      }
                      onClick={() =>
                        this.setState({
                          activeInsite: FIELD,
                          zoomChartData: careerBreakdown,
                        })
                      }
                      active={activeInsite === FIELD}
                      isMobile={isMobile}
                    />
                  </div>
                  <div className="row m-0">
                    <div className="col" style={{ padding: 10 }}>
                      <Insight
                        content={insight.content}
                        willShow={insight.chart === 'bachelorChart'}
                      >
                        <ResultGauge
                          gaugeFieldData={advancedDegreeData}
                          chartHeight={200}
                          textBottom={false}
                          content="Have an advanced degree"
                          onClick={() =>
                            this.setState({
                              activeInsite: ADVANCED_DEGREE,
                              zoomChartData: zoomDegreeData,
                            })
                          }
                          active={activeInsite === ADVANCED_DEGREE}
                          isMobile={isMobile}
                        />
                      </Insight>
                    </div>
                  </div>
                </div>
              )}
              {!isMobile && (
                <div className="col-md-6" id="zoomEducationContainer">
                  {activeInsite !== null ? (
                    <EducationDetailChart
                      chartData={zoomChartData}
                      header={zoomChartContent[activeInsite].header}
                      tipContent={zoomChartContent[activeInsite].tipContent}
                      elementId={zoomChartContent[activeInsite].header}
                    />
                  ) : (
                    <div
                      style={{
                        backgroundColor: 'white',
                        color: 'gray',
                      }}
                    >
                      <div className="p-4 text-center" style={{ marginTop: 100 }}>
                        Click&nbsp;
                        <img src={click} style={{ width: 25 }} alt="icon" />
                        <br />
                        on the left for details <br />
                        <i className="fal fa-hand-point-left fa-2x" />
                      </div>
                    </div>
                  )}
                </div>
              )}
              {isMobile && (
                <div
                  style={{
                    paddingTop: 10,
                    width: '100%',
                  }}
                >
                  <div className="accordion" id="accordion">
                    <div className="card" style={{ marginBottom: '0' }}>
                      <div
                        className="card-header"
                        id="degreeHeading"
                        style={{
                          backgroundColor: '#ffffff',
                          borderBottom: '0',
                        }}
                      >
                        <div data-toggle="collapse" data-target="#collapseOne">
                          {zoomChartContent.advancedDegree.header}
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className="collapse show"
                        aria-labelledby="degreeHeading"
                        data-parent="#accordion"
                      >
                        <EducationDetailChart
                          chartData={zoomDegreeData}
                          tipContent={zoomChartContent.advancedDegree.tipContent}
                          isMobile
                          elementId={`zoomChartContent${activeInsite}`}
                        />
                      </div>
                    </div>
                    <div className="card" style={{ marginBottom: '0' }}>
                      <div
                        className="card-header"
                        id="majorHeading"
                        style={{
                          backgroundColor: '#ffffff',
                          borderTop: '1px solid rgba(0, 0, 0, 0.125)',
                          borderBottom: '0',
                        }}
                        onClick={this.showTopMajors}
                      >
                        <div
                          className="collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                        >
                          {zoomChartContent.field.header}
                        </div>
                      </div>
                      <div
                        id="collapseTwo"
                        className="collapse"
                        aria-labelledby="majorHeading"
                        data-parent="#accordion"
                      >
                        <EducationDetailChart
                          chartData={careerBreakdown}
                          tipContent={zoomChartContent.field.tipContent}
                          isMobile
                          elementId="degree-chart"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const educationPage1 = [
  {
    selector: '#statContainer',
    content: 'Click on any stat to view details on the right',
  },
  {
    selector: '#zoomEducationContainer',
    content: 'Clickable, interactive charts will appear here when you select any box on the left',
  },
  {
    selector: '#search360Tabs',
    content: "Click other tabs here when you're ready for more",
  },
]

export default withTour('educationPage1', educationPage1)(EducationResult)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Education/components/EducationResult.js